import React from 'react';
import { AppleIcon, SparklesIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full min-h-screen bg-[#0A0A0F] flex items-center justify-center overflow-hidden" data-id="element-85">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0F] via-[#1A1A2E] to-[#0A0A0F] opacity-50" data-id="element-86"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 lg:py-32" data-id="element-87">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-88">
          <div className="text-center lg:text-left" data-id="element-89">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#3B9EFF]/10 border border-[#3B9EFF]/20 rounded-full mb-8" data-id="element-90">
              <SparklesIcon className="w-4 h-4 text-[#3B9EFF]" data-id="element-91" />
              <span className="text-sm font-medium text-[#3B9EFF] tracking-wide uppercase" data-id="element-92">
                Artreal
              </span>
            </div>

            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black text-white leading-[1.1] mb-6 tracking-tight" data-id="element-93">
              Tired of every art print looking the same?
            </h1>

            <p className="text-xl sm:text-2xl text-gray-400 mb-10 leading-relaxed" data-id="element-94">
              AI rooms made for your art — not stock photos.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-95">
              <a href="https://apps.apple.com/us/app/artreal-ai-art-mockup-studio/id6766778360" target="_blank" rel="noopener noreferrer" className="group px-8 py-4 bg-[#3B9EFF] hover:bg-[#2B8EEF] text-white font-bold rounded-xl transition-all duration-200 flex items-center justify-center gap-3 shadow-lg shadow-[#3B9EFF]/20 hover:shadow-xl hover:shadow-[#3B9EFF]/30" data-id="element-96">
                <AppleIcon className="w-5 h-5" data-id="element-97" />
                Download on iOS
              </a>
            </div>

            <div className="mt-10 flex items-center gap-6 justify-center lg:justify-start text-sm text-gray-500" data-id="element-98">
              <div className="flex items-center gap-2" data-id="element-99">
                <div className="flex -space-x-2" data-id="element-100">
                  <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop&crop=faces" alt="Artist" className="w-8 h-8 rounded-full object-cover border-2 border-[#0A0A0F]" data-id="element-101" />
                  <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop&crop=faces" alt="Artist" className="w-8 h-8 rounded-full object-cover border-2 border-[#0A0A0F]" data-id="element-102" />
                  <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=faces" alt="Artist" className="w-8 h-8 rounded-full object-cover border-2 border-[#0A0A0F]" data-id="element-103" />
                </div>
                <span data-id="element-104">10,000+ artists</span>
              </div>
              <div className="w-1 h-1 rounded-full bg-gray-600" data-id="element-105"></div>
              <span data-id="element-106">4.9★ on App Store</span>
            </div>
          </div>

          <div className="relative flex justify-center lg:justify-end" data-id="element-107">
            <div className="relative" data-id="element-108">
              <div className="absolute inset-0 bg-gradient-to-br from-[#3B9EFF]/20 to-[#F5C842]/20 blur-3xl rounded-full" data-id="element-109"></div>
              <img src="https://cdn.magicpatterns.com/uploads/kAdtYfzvMN7AqYX4MnF3aU/0x0ss_(43).png" alt="Artreal app showing bedroom mockup" className="relative w-full max-w-sm lg:max-w-md drop-shadow-2xl" data-id="element-110" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}